"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isDiscount = _interopRequireDefault(require("@deosite/helpers/isDiscount"));
var _totalPrice = _interopRequireDefault(require("@deosite/helpers/totalPrice"));
var _usePriceWithCurrency = _interopRequireDefault(require("@deosite/api/hooks/common/usePriceWithCurrency"));
var useProductRowPrice = function useProductRowPrice(_ref) {
  var price = _ref.price,
    isQuantityPickerEnabled = _ref.isQuantityPickerEnabled,
    quantityPicker = _ref.quantityPicker,
    quantity = _ref.quantity,
    showDiscountFromTotals = _ref.showDiscountFromTotals;
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var hasDiscount = (0, _isDiscount["default"])(price.regular, price.special);
  var discountFromTotals = price.discountFromTotals;
  var qty = isQuantityPickerEnabled ? quantityPicker.amount : quantity;
  if (isQuantityPickerEnabled && quantityPicker.amount !== quantity) {
    var discountPerItem = discountFromTotals / quantity;
    discountFromTotals = discountPerItem * quantityPicker.amount;
  }
  var finalPrice = (hasDiscount ? price.special : price.regular) * qty;
  var finalRegularPrice = price.regular * qty;
  if (showDiscountFromTotals && discountFromTotals) {
    if (hasDiscount) {
      finalPrice = finalPrice - discountFromTotals;
      finalRegularPrice = (price.special || price.regular) * qty;
    }
    if (!hasDiscount) {
      finalPrice = finalRegularPrice - discountFromTotals;
      hasDiscount = true;
    }
  }
  return {
    isProductForFree: finalPrice === 0,
    finalPrice: priceWithCurrency((0, _totalPrice["default"])(finalPrice, 1), true),
    finalRegularPrice: priceWithCurrency((0, _totalPrice["default"])(finalRegularPrice, 1), true),
    hasDiscount: hasDiscount
  };
};
var _default = useProductRowPrice;
exports["default"] = _default;